
import { h, Fragment } from 'preact'
import classnames from 'classnames'

export function FieldBasic({ label, description, name, type = 'text', error, children, ...props }) {
	
	const containerClasses = classnames(
		'input',
		error && 'input--error'
	)
	
	const inputClasses = classnames(
		props['class'] || '',
		props['className'] || '',
		error && 'input__field--error'
	)

	return <>
		<label class={containerClasses}>
			{label && <span class="input__label">{label}</span>}
			{description && <div class="input__description">{description}</div>}
			<input name={name} type={type} class={inputClasses} {...props} />
			{error && <div class="input__error">{error}</div>}
		</label>
	</>
}